import * as React from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';

import { MessagesState, AppState } from 'src/store';

const mapStateToProps = ({ messagesState }: AppState) => {
  return {
    messagesState,
  };
};
interface P {
  messagesState: MessagesState;
}
class Toast extends React.Component<P> {
  componentWillReceiveProps(nextProps: P) {
    const { messagesState: { messages } } = nextProps;
    while (messages.length > 0) {
      const msg = messages.shift();
      if (msg) {
        switch (msg.type) {
          case 'success': {
            message.success(msg.content);
            break;
          }
          case 'error': {
            message.error(msg.content);
            break;
          }
          default:
            message.info(msg.content);
        }
      }
    }
  }

  render() {
    return null;
  }
}

export default connect(mapStateToProps)(Toast);



// WEBPACK FOOTER //
// ./src/toast/containers/Toast.tsx